import React from 'react'
import { Link } from 'gatsby'

import Layout from '../layouts/layout'
import SEO from '../components/seo'
import TitleHeader from '../components/titleheader'
import Card from '../components/card'


// Images
import headerimage from '../assets/images/careers/Corprate_Careers_03.jpg'
import mbheaderimage from '../assets/images/careers/Corprate_CareersMB-Header_03.jpg'
import annualreports from '../assets/images/investor/AnnualReports_02.jpg'
import governance from '../assets/images/investor/Governance_01.jpg'
import secfiling from '../assets/images/investor/SEC_Filings_02.jpg'
import ircontact from '../assets/images/investor/IR_Contacts_01.jpg'
import pressreleases from '../assets/images/investor/Press_Releases_01.jpg'
import investorPresentation from '../assets/images/investor/investorpresentation.jpg'

import { trackPageData, getPageDetails } from '../analytics/index'

const iconStyle = {
  height: '80px !important',
  marginBottom: '10px !important',
  verticalAlign: 'bottom',
}

class Careers extends React.PureComponent {
  constructor(props) {
    super(props)

    let dataManager = {
      pageDetails: {},
    }
    if (typeof window !== `undefined`) {
      if (window.dataManager) {
        dataManager = window.dataManager
      }
    }
    dataManager.pageDetails = getPageDetails()
  }

  componentDidMount() {
    trackPageData()
  }

  render() {
    return (
      <Layout>
        <SEO title="Investor Relations | The Children's Place Corporate Website" description="The Investor Relations website contains information about The Children's Place's business for stockholders, potential investors, and financial analysts." /> {/* Page Title & Header Image */} <div class="row mb-4">
          <div class="col-12 text-center">
            <TitleHeader image={headerimage} mbheaderimage={mbheaderimage} title="Investor Relations" />
            <div class="row justify-content-center">
              <div class=" col-12">
                <p> The Children’s Place is the largest pure-play children’s specialty retailer in North America with an omni-channel portfolio of brands and an industry-leading digital-first model. Its global retail and wholesale network includes two digital storefronts, 495 stores in North America, wholesale marketplaces and distribution in 13 countries through six international franchise partners. The Children’s Place designs, contracts to manufacture, and sells fashionable, high-quality, head-to-toe outfits predominantly at value prices, primarily under its proprietary brands: “The Children’s Place” and “Gymboree”. For more information, visit: <a target='_blank' href="https://www.childrensplace.com/us/home">www.childrensplace.com</a> and <a target='_blank' href="https://www.gymboree.com/us/home">www.gymboree.com</a>. <br/> <br/>  <a target='_blank' href="https://corporate.childrensplace.com/static/2025_Sidoti-Conference-Final.pdf">Current Investor Presentation – Sidoti Conference 9.18.25</a></p>
              </div>
            </div>
          </div>
        </div>
        <div id="collapseCareers" class=" d-md-block"> {' '} <div class="row mb-5">
            <div id="annualreports" class="col-md-6 col-sm-12">
              <a target="_blank" href="https://newsplace.childrensplace.com/annual-reports-proxies/">
                <Card classname="mb-border-bottom" image={annualreports} title="Annual Reports & Proxy" description=""></Card>
              </a>
            </div>
            <div id="governance" class="col-md-6 col-sm-12 d-md-block ">
              <a target="_blank" href="https://newsplace.childrensplace.com/governance-documents/">
                <Card classname="mb-border-bottom" image={governance} title="Governance Documents" description=""></Card>
              </a>
            </div>
          </div>
          <div class="row mb-5">
            <div id="secfiling" class="col-md-6 col-sm-12 ">
              <a target="_blank" href="https://www.sec.gov/cgi-bin/browse-edgar?CIK=0001041859&owner=exclude">
                <Card classname="mb-border-bottom" image={secfiling} title="SEC Filings" description=""></Card>
              </a>
            </div>
            <div id="presentations" class="col-md-6 col-sm-12 ">
              <a target="_blank" href="https://corporate.childrensplace.com/static/2025_Sidoti-Conference-Final.pdf">
                <Card classname="mb-border-bottom" image={investorPresentation} title="Investor Presentations" description=""></Card>
              </a>
            </div>
          </div>
          <div class="row mb-5">
            <div id="pressreleases" class="col-md-6 col-sm-12 ">
              <a target="_blank" href="https://newsplace.childrensplace.com/">
                <Card classname="mb-border-bottom" image={pressreleases} title="Press Releases" description=""></Card>
              </a>
            </div>
            <div id="ircontact" class="col-md-6 col-sm-12 d-md-block">
              <a target="_blank" href="https://newsplace.childrensplace.com/ir-contacts-info/">
                <Card classname="mb-border-bottom" image={ircontact} title="IR Contact Info" description=""></Card>
              </a>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Careers
